export const EDITOR_TEST_ID = 'modify-subscription-editor';
export const INFO_MESSAGE_ID = 'info-message';

// Relevant info messages for Modify Subscription Editor
export const INFO_MESSAGES = {
  SUBSCRIBE_TO_CHANNEL:
    'Note: Subscribing contacts to a channel won’t overwrite their individual subscription preferences for the channel’s message types.',
  SUBSCRIBE_TO_MESSAGE_TYPE:
    'Note: Contacts who have previously unsubscribed from this message type will be resubscribed to it.',
  UNSUBSCRIBE_FROM_CHANNEL:
    'Note: Contacts who have subscribed to message types within this channel will no longer receive any messages from this channel.',
  UNSUBSCRIBE_FROM_MESSAGE_TYPE:
    'Note: Contacts who have previously subscribed to this message type will be unsubscribed from it.',
};

export enum SubscriptionAction {
  Subscribe = 'Subscribe',
  Unsubscribe = 'Unsubscribe',
}

export const SUBSCRIPTION_ACTION_OPTIONS = [
  {
    id: 'Subscribe user to...',
    value: SubscriptionAction.Subscribe,
    name: 'Subscribe user to...',
  },
  {
    id: 'Unsubscribe user from...',
    value: SubscriptionAction.Unsubscribe,
    name: 'Unsubscribe user from...',
  },
];

export const modifySubscriptionText = { channel: 'channel', type: 'type' };
